import {createSlice} from "@reduxjs/toolkit";

const bankSlice = createSlice({
    name: "bankRedux",
    initialState: {
        banks: []
    },
    reducers: {
        addBank: (state, action) => {
            state.banks.push(action.payload);
        },

        editBank: (state, action) => {
            const updatedBank = action.payload;
            for(const item of state.banks){
                if(item.bankId === updatedBank.bankId){
                    item.bankName = updatedBank.bankName;
                    item.bankDesc = updatedBank.bankDesc;
                    item.bankCode = updatedBank.bankCode;
                    break;
                }
            }
            
        },
        
    }
});

export const {addBank, editBank} = bankSlice.actions;
export default bankSlice.reducer;